import Button from '@rio-cloud/rio-uikit/Button';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { useIntl } from 'react-intl';

type CancelDialogProps = {
    show: boolean;
    isLoading: boolean;
    title: string;
    content: string;
    onClickConfirm: () => void;
    onClickCancel: () => void;
    cancelLabel?: string;
    confirmLabel?: string;
    confirmIconName?: string;
    cancelTrackingKey?: string;
    confirmTrackingKey?: string;
};

export const CancelDialog = ({
    show,
    isLoading,
    title,
    content,
    onClickConfirm,
    onClickCancel,
    cancelLabel,
    confirmLabel,
    confirmIconName,
    cancelTrackingKey,
    confirmTrackingKey,
}: CancelDialogProps) => {
    const intl = useIntl();
    const cancelText =
        cancelLabel ??
        intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.cancel.dialog.cancel', defaultMessage: 'Retained' });
    const confirmText =
        confirmLabel ??
        intl.formatMessage({ id: 'intl-msg:ordercom-cloud-frontend.cancel.dialog.confirm', defaultMessage: 'Remove' });

    const renderFooter = () => {
        return (
            <div className='btn-toolbar'>
                <Spinner
                    isFullSized
                    show={isLoading}
                    text={intl.formatMessage({
                        id: 'intl-msg:ordercom-cloud-frontend.cancel.dialog.confirm',
                        defaultMessage: 'Remove',
                    })}
                />
                <Button
                    disabled={isLoading}
                    autoTrackingKey={cancelTrackingKey ?? 'intl-msg:ordercom-cloud-frontend.cancel.dialog.cancel'}
                    onClick={() => onClickCancel()}
                >
                    {cancelText}
                </Button>
                <Button
                    disabled={isLoading}
                    bsStyle={Button.PRIMARY}
                    iconName={confirmIconName ?? 'rioglyph-ok'}
                    autoTrackingKey={confirmTrackingKey ?? 'intl-msg:ordercom-cloud-frontend.cancel.dialog.confirm'}
                    onClick={() => onClickConfirm()}
                >
                    {confirmText}
                </Button>
            </div>
        );
    };

    return (
        <Dialog
            show={show}
            title={title}
            body={content}
            bsSize={Dialog.SIZE_SM}
            footer={renderFooter()}
            useOverflow
            onClose={onClickCancel}
        />
    );
};
